export default __webpack_public_path__ + "static/media/prisma_black.6f3ce4bb.png";